import BWAccordion from 'components/shared/BWAccordion/index';
import FormEditorQuill from 'components/shared/BWFormControl/FormEditorQuill';
import React from 'react';

const JobDescriptionEn = ({ disabled, title, id }) => {
  return (
    <BWAccordion title={title} id={id}>
      <FormEditorQuill field='job_description_en' disabled={disabled} />
    </BWAccordion>
  );
};

export default JobDescriptionEn;
